import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@environments/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/configs/app.config';

if (environment.production) {
  enableProdMode();
}

function loadGoogleAnalytics(): void {
  const script1 = document.createElement('script');
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsKey}`;
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
   window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', '${environment.googleAnalyticsKey}');
  `;
  document.head.appendChild(script2);
}

if (!environment.isTestSite) {
  loadGoogleAnalytics();
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js', { scope: '/ru' });
    navigator.serviceWorker.register('/sw.js', { scope: '/en' });
    navigator.serviceWorker.register('/sw.js', { scope: '/zh' });
  }
}

bootstrapApplication(AppComponent, appConfig).catch(error => console.log(error));
